import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  NavBarContainer,
  MainContentWrapper,
  ContentWrapper,
  LogoWrapper,
  ActionWrapper,
  LoginWrapper,
  IconWrapperLogin,
} from './style';
import { Logo, Text } from '../../../atoms';
import routes from '../../../../routes';
import Icon from '../../../atoms/Icon';

const NavBarPublic = ({ isLogged }) => {
  const navigate = useNavigate();

  return (
    <NavBarContainer>
      <ContentWrapper>
        <ActionWrapper>
          <LogoWrapper>
            <Logo size={Logo.SIZE.SMALL} defaultLogo />
          </LogoWrapper>
          <MainContentWrapper>
            <LoginWrapper
              onClick={() =>
                navigate(isLogged ? routes.home.path : routes.auth.path)
              }
            >
              <IconWrapperLogin>
                <Icon
                  type="arrow-circle-broken-left"
                  size={20}
                  rotate={180}
                  fill="none"
                />
              </IconWrapperLogin>
              <Text type="h3">Accedi all'area personale</Text>
            </LoginWrapper>
          </MainContentWrapper>
        </ActionWrapper>
      </ContentWrapper>
    </NavBarContainer>
  );
};

NavBarPublic.propTypes = { isLogged: PropTypes.bool };

export default NavBarPublic;
